import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuration4 = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7968 8.9203 A9.35 9.35 0 1 0 17.9732 27.148 A9.35 9.35 0 1 0 13.7968 8.9203 Z M15.8876 8.6875 L15.8792 5.427 M13.6719 5.4198 L18.0866 5.4342 M6.6906 9.3379 L8.3459 7.6968 M23.4189 7.7518 L25.0675 9.3951",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7968 8.9203 A9.35 9.35 0 1 0 17.9732 27.148 A9.35 9.35 0 1 0 13.7968 8.9203 Z",
				style: { fill: "var(--sticker-pastel,#D0DBFF)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7968 8.9203 A9.35 9.35 0 1 0 17.9732 27.148 A9.35 9.35 0 1 0 13.7968 8.9203 Z M15.8876 8.6875 L15.8792 5.427 M13.6719 5.4198 L18.0866 5.4342 M6.6906 9.3379 L8.3459 7.6968 M23.4189 7.7518 L25.0675 9.3951",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#505772)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.885 18.0341 L15.885 9.437 A8.6 8.6 0 0 1 21.9677 24.1193 Z",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: {
					fill: "var(--sticker-dark,#505772)",
					stroke: "var(--sticker-dark,#505772)"
				}
			})
		]
	});
};
export default SvgDuration4;
